<template lang="pug" src="./templates/Register.pug"></template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, minLength } from 'vuelidate/lib/validators';
import FacebookLoginButton from '../buttons/auth/FacebookLoginButton.vue';
import notify from '../notify';

export default {
  components: {
    FacebookLoginButton,
  },
  mixins: [validationMixin],
  data() {
    return {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      tel: '',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    first_name: { required },
    last_name: { required },
    password: {
      required,
      minLength: minLength(8),
      strongPassword(password) {
        return (
          /[a-z]/.test(password) // checks for a-z
          && /[0-9]/.test(password) // checks for 0-9
          // /\W|_/.test(password) && // checks for special char
          && password.length >= 8
        );
      },
    },
    tel: { required },
  },
  methods: {
    async authenticate() {
      this.$wait.start('registering');
      notify.loading(this, { title: Lang.get('alerts.frontend.general.registering'), text: false });
      try {
        await this.$store.dispatch('auth/register', {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          password: this.password,
          tel: this.tel,
        });
        notify.clean(this).then(() => notify.success(this, { title: Lang.get('alerts.frontend.general.registered'), text: false }));
      } catch (e) {
        notify.clean(this).then(() => notify.errors(this, e));
      }
      this.$wait.end('registering');
    },
  },
};
</script>
